import React from 'react';
import { NavLink, useLocation } from 'react-router-dom';
import styled from 'styled-components';
import { isPortalSectionTabActive } from './portalSectionTabActive';

const NavbarWrapper = styled.div`

  font-family: ${({ theme }) => theme.fontBody};
  font-size: ${({ theme }) => theme.fsSm};
  display: flex;
  align-items: center;
  min-height: 0;
  width: min(1180px, 100%);
  margin: 0 auto ${({ theme }) => theme.space};
  background: transparent;
  border-bottom: 1px solid ${({ theme }) => theme.border};
  overflow-x: auto;

  @media (max-width: 768px) {
    font-size: ${({ theme }) => theme.fsSm};
    width: calc(100% - 80px);
    margin-left: 64px;
    margin-top: 0;
  }
`;

const MenuList = styled.ul`
  width: 100%;
  margin: 0;
  padding: 0;
  display: flex;
  gap: 4px;
  justify-content: flex-start;
  align-items: center;
  list-style: none;
  flex-wrap: nowrap;
`;

const MenuItem = styled.li`
  display: inline-block;
  white-space: nowrap;

  a {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    padding: 0 0 12px;
    margin-right: 22px;
    margin-bottom: -1px;
    border-bottom: 2px solid transparent;
    text-decoration: none;
    color: ${({ theme }) => theme.textMuted};
    font-size: ${({ theme }) => theme.fsSm};
    font-weight: 650;
    transition: color .15s ease, border-color .15s ease;
    white-space: nowrap;

    &:hover {
      color: ${({ theme }) => theme.accentStrong};
    }

    &.active-link {
      color: ${({ theme }) => theme.accentStrong};
      border-bottom-color: ${({ theme }) => theme.accent};
    }

    @media (max-width: 768px) {
      font-size: 0.9em;
      padding: 0 10px;
    }
  }
`;

const DashboardNavbar = ({ menuItems = [] }) => {
  const location = useLocation();

  if (!menuItems.length) return null;

  return (
    <NavbarWrapper role="navigation" aria-label="Dashboard navigation">
      <MenuList>
        {menuItems.map((item, index) => (
          <MenuItem key={index}>
            <NavLink
              to={item.link}
              className={() => (
                isPortalSectionTabActive(location, item.link) ? 'active-link' : ''
              )}
              onClick={item.onClick}
            >
              {item.title}
            </NavLink>
          </MenuItem>
        ))}
      </MenuList>
    </NavbarWrapper>
  );
};

export default DashboardNavbar;
